<template>
	<div id="tasks" class="block_3">
		<div class="wrap">

			<h2 class="name">
				Для решения каких задач
			</h2>

			<div class="desc">
				проводят деловые игры?
			</div>

			<div class="wrap">

				<div class="left">

					<div v-for="object in objects" :key="object.id" class="btn">

						<div @click="select(object)" :class="['wrap', {active: object.active}]">

							<h3 class="name">{{ object.name }}</h3>

							<svg :class="[{active: object.active}]" width="30" height="19" viewBox="0 0 30 19" fill="none" xmlns="http://www.w3.org/2000/svg">

								<g clip-path="url(#clip0_757_5088)">
									<path d="M15.0064 14.8656L1.96764 1.65296C1.74781 1.45205 1.46025 1.34434 1.16432 1.35206C0.868386 1.35979 0.586679 1.48236 0.377355 1.69448C0.16803 1.90659 0.0470697 2.19206 0.039446 2.49194C0.0318222 2.79181 0.138117 3.08321 0.336386 3.30596L14.187 17.347C14.637 17.803 15.3683 17.803 15.8201 17.347L29.6726 3.30976C29.8709 3.08701 29.9772 2.79561 29.9696 2.49574C29.962 2.19586 29.841 1.9104 29.6317 1.69828C29.4223 1.48616 29.1406 1.36359 28.8447 1.35586C28.5488 1.34814 28.2612 1.45585 28.0414 1.65676L15.0064 14.8656Z" fill="currentColor"/>
								</g>

								<defs>
									<clipPath id="clip0_757_5088">
										<rect width="19" height="30" fill="currentColor" transform="translate(0 19) rotate(-90)"/>
									</clipPath>
								</defs>

							</svg>

						</div>

						<div v-if="object.active" class="info">

							<div class="top">

								<div class="icon" v-html="object.info.icon"></div>

								<div class="name">
									{{ object.info.name }}
								</div>

							</div>

							<div class="center">

								<div v-for="paragraph in object.info.paragraphs" :key="paragraph.id" class="wrap">

									<svg width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.52 3.92C1.32 3.92 1.15 3.85 1.01 3.71C0.87 3.57 0.8 3.4 0.8 3.2V0.8C0.8 0.599999 0.87 0.429999 1.01 0.289999C1.15 0.149999 1.32 0.0799993 1.52 0.0799993H19.25C19.45 0.0799993 19.62 0.149999 19.76 0.289999C19.9 0.429999 19.97 0.599999 19.97 0.8V3.2C19.97 3.4 19.9 3.57 19.76 3.71C19.62 3.85 19.45 3.92 19.25 3.92H1.52Z" fill="#FFDD2D"/>
									</svg>

									<div class="name">
										{{ paragraph.name }}
									</div>

								</div>

							</div>

							<div class="desc">
								{{ object.info.desc }}
							</div>
								
						</div>

					</div>

					<!-- 
						<a href="#orders" v-smooth-scroll class="link">
							Это то, что нужно!
						</a>
					-->

				</div>

				<div class="right">

					<div v-for="object in filter_objects" :key="object.id" class="info">

						<div class="top">

							<div class="icon" v-html="object.info.icon"></div>

							<div class="name">
								{{ object.info.name }}
							</div>

						</div>

						<div class="center">

							<div v-for="paragraph in object.info.paragraphs" :key="paragraph.id" class="wrap">

								<svg width="20" height="4" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1.52 3.92C1.32 3.92 1.15 3.85 1.01 3.71C0.87 3.57 0.8 3.4 0.8 3.2V0.8C0.8 0.599999 0.87 0.429999 1.01 0.289999C1.15 0.149999 1.32 0.0799993 1.52 0.0799993H19.25C19.45 0.0799993 19.62 0.149999 19.76 0.289999C19.9 0.429999 19.97 0.599999 19.97 0.8V3.2C19.97 3.4 19.9 3.57 19.76 3.71C19.62 3.85 19.45 3.92 19.25 3.92H1.52Z" fill="#FFDD2D"/>
								</svg>

								<div class="name">
									{{ paragraph.name }}
								</div>

							</div>

						</div>

						<div class="desc">
							{{ object.info.desc }}
						</div>
							
					</div>
				</div>

			</div>


		</div>
	</div>
</template>

<script>

import { useStore } from 'vuex'
import { computed, ref } from 'vue'

export default {

	setup(){

		const store = useStore()
		const domain = computed(() => store.getters.domain)

		const objects = ref([

			{	
				id: 1,
				name: `Обучение`,
				active: false,
				info: {
					icon: `
					<svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700" fill="#1A2030" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<g>
					<path d="m602 543.2h-515.2v-515.2h22.398v492.8h492.8z"/>
					<path d="m150.64 388.64-15.68-15.68 179.76-174.16 89.602 50.398 147.84-140 15.68 16.801-160.16 151.2-89.602-50.398z"/>
					<path d="m579.6 168h-22.402v-50.398h-50.398v-22.402h72.801z"/>
					<path d="m165.2 403.2v84h54.879v-140z"/>
					<path d="m243.6 324.8v162.4h54.879v-218.4z"/>
					<path d="m322 257.6v229.6h54.879v-201.6z"/>
					<path d="m400.4 296.8v190.4h54.883v-224l-43.68 39.199z"/>
					<path d="m478.8 246.4v240.8h54.879v-296.8z"/>
					</g>
					</svg>
					`,

					name: `Бизнес-симулятор моделирует процесс, максимально приближенный к реальности. Здесь можно проверить свои теории и без последствий совершить любые ошибки. Это развивает: `,

					paragraphs: [
						{id: 1, name: 'навыки принятия решений и умение ставить цели',},
						{id: 2, name: 'умение работать в условиях неопределенности',},
						{id: 3, name: 'понимание взаимосвязей между решениями',},
						{id: 4, name: 'умение предугадывать действия конкурентов',},
					],

					desc: `Моделирование рынка позволяет понять законы конкуренции и внутреннее устройство компании.`,

				},
			},

			{	id: 2,
				name: `Оценка`,
				active: false,
				info: {
					icon: `
						<svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700" fill="#1A2030" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g>
							<path d="m142.8 400.4h158.42c10.734 19.562 26.539 35.863 45.758 47.199 19.215 11.332 41.133 17.273 63.445 17.203 22.613-0.019531 44.801-6.1953 64.176-17.863l60.199 60.141c3.4297 3.4102 8.0703 5.3242 12.906 5.3242 4.8359 0 9.4766-1.9141 12.91-5.3242l16.801-16.801-0.003907 0.003906c3.4219-3.4141 5.3438-8.0508 5.3438-12.883 0-4.832-1.9219-9.4648-5.3438-12.879l-59.922-59.922 0.003906 0.003906c14.312-23.832 20.258-51.762 16.891-79.359-3.3711-27.594-15.855-53.273-35.484-72.961-13.523-13.469-29.988-23.609-48.102-29.625v-149.86c-0.046875-6.6914-2.7305-13.09-7.4688-17.809-4.7422-4.7227-11.156-7.3789-17.844-7.3906h-282.69c-6.6719 0.042969-13.055 2.7109-17.77 7.4297-4.7188 4.7148-7.3867 11.098-7.4297 17.77v302.4c0.042969 6.6719 2.7109 13.055 7.4297 17.77 4.7148 4.7188 11.098 7.3867 17.77 7.4297zm-8.4023-327.6c0.0625-4.6133 3.7891-8.3398 8.4023-8.4023h282.69c4.6562 0 8.4492 3.7461 8.5117 8.4023v145.26c-9.9258-1.8672-20.047-2.5039-30.129-1.9023v-68.938c0-4.6367-3.7617-8.3984-8.3984-8.3984h-45.473c-4.6406 0-8.3984 3.7617-8.3984 8.3984v89.602c-6.9141 4.5664-13.352 9.8203-19.211 15.68-2.6328 2.6875-5.0977 5.6016-7.5039 8.3438v-49.336c0-4.6406-3.7578-8.3984-8.3984-8.3984h-45.695c-4.6406 0-8.4023 3.7578-8.4023 8.3984v136.42c0 4.6367 3.7617 8.3984 8.4023 8.3984h26.152c1.2188 9.3086 3.4531 18.453 6.6641 27.273h-150.81c-4.6133-0.0625-8.3398-3.7891-8.4023-8.4023zm430.75 405.61-16.801 16.801c-0.26172 0.27344-0.62891 0.42969-1.0078 0.42969s-0.74219-0.15625-1.0078-0.42969l-57.68-57.734c6.9258-5.582 13.234-11.891 18.816-18.816l57.68 57.734c0.27344 0.26562 0.42969 0.62891 0.42969 1.0078 0 0.38281-0.15625 0.74609-0.42969 1.0078zm-78.398-61.602v0.003906c-20.227 20.199-47.641 31.539-76.227 31.527-28.582-0.011719-55.988-11.375-76.195-31.59s-31.559-47.629-31.559-76.211c0-28.582 11.352-55.996 31.559-76.211 20.207-20.215 47.613-31.578 76.195-31.59 28.586-0.011719 56 11.332 76.227 31.531 20.16 20.242 31.477 47.652 31.465 76.227-0.011719 28.57-11.348 55.973-31.523 76.203zm-99.684-198.74c-9.9375 1.918-19.602 5.0391-28.781 9.2969v-71.734h28.785zm-117.6 121.46 0.003906-119.62h28.785v67.203c-7.8086 16.438-11.938 34.383-12.098 52.582z"/>
							<path d="m171.7 356.33h45.586c4.6367 0 8.3984-3.7617 8.3984-8.3984v-72.129c0-4.6406-3.7617-8.4023-8.3984-8.4023h-45.586c-4.6367 0-8.3984 3.7617-8.3984 8.4023v72.129c0 4.6367 3.7617 8.3984 8.3984 8.3984zm8.3984-72.129h28.785v55.328h-28.781z"/>
							<path d="m494.43 340.43c0-22.281-8.8516-43.645-24.605-59.398-15.754-15.754-37.117-24.602-59.395-24.602-22.281 0-43.645 8.8477-59.398 24.602s-24.602 37.117-24.602 59.398c0 22.277 8.8477 43.641 24.602 59.395 15.754 15.754 37.117 24.605 59.398 24.605 22.277 0 43.641-8.8516 59.395-24.605 15.754-15.754 24.605-37.117 24.605-59.395zm-151.2 0h-0.003906c0-17.824 7.082-34.918 19.684-47.52s29.695-19.684 47.52-19.684c17.82 0 34.914 7.082 47.516 19.684 12.602 12.602 19.684 29.695 19.684 47.52 0 17.82-7.082 34.914-19.684 47.516-12.602 12.602-29.695 19.684-47.516 19.684-17.816-0.015625-34.895-7.1016-47.484-19.703s-19.66-29.684-19.66-47.496z"/>
							<path d="m189.95 230.72c3.8828 2.5117 9.0625 1.4102 11.59-2.4609l36.062-55.496 44.016 10.754 0.003906-0.003906c3.5039 0.83984 7.1523-0.64453 9.0703-3.6953l39.199-61.32 45.359-13.664h0.003906c2.2344-0.54688 4.1484-1.9883 5.293-3.9883 1.1406-1.9961 1.4141-4.375 0.75391-6.582-0.66016-2.207-2.1953-4.043-4.25-5.082-2.0547-1.043-4.4453-1.1914-6.6133-0.41797l-48.441 14.559c-1.9336 0.55859-3.5898 1.8164-4.6484 3.5273l-37.574 58.914-43.961-10.754c-3.4609-0.85547-7.0859 0.58594-9.0156 3.5859l-39.199 60.48v-0.003907c-1.2344 1.8594-1.6797 4.1289-1.2383 6.3125 0.44141 2.1836 1.7305 4.1055 3.5898 5.3359z"/>
							</g>
						</svg>
					`,

					name: `На базе игры можно организовать оценку сотрудников в формате ассессмент-центра. Финальная персональная оценка может складываться из следующих показателей:`,

					paragraphs: [
						{id: 1, name: 'результаты эффективности управления компанией, которые рассчитываются автоматически по итогам игры',},
						{id: 2, name: 'персональные качества участников, которые оцениваются ассессорами в процессе игры',},
						{id: 3, name: 'оценки коллег и самооценка',},
					],

					desc: `Для каждого сотрудника возможно сформировать ИПР – индивидуальный план развития, который помогает эффективнее двигаться вперед, не теряя фокус.`,

				},
			},

			{	
				id: 3,
				name: `Тимбилдинг`,
				active: true,
				info: {
					icon: `
					<svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700" fill="#1A2030" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g>
							<path d="m509.51 64.227c-27.312 0-53.508 10.848-72.824 30.164-19.312 19.312-30.164 45.508-30.164 72.82 0 27.316 10.852 53.512 30.164 72.824 19.316 19.312 45.512 30.164 72.824 30.164 27.316 0 53.512-10.852 72.824-30.164s30.164-45.508 30.164-72.824c0-27.312-10.852-53.508-30.164-72.82-19.312-19.316-45.508-30.164-72.824-30.164zm0 190.14c-23.98-0.019531-46.879-9.9648-63.262-27.477 7.5273-10.945 17.742-19.773 29.664-25.637 10.438 5.2031 21.934 7.9258 33.598 7.9609 11.691-0.023438 23.223-2.75 33.688-7.9609 11.934 5.8008 22.176 14.57 29.75 25.461-16.402 17.605-39.375 27.617-63.438 27.652zm73.5-40.336v-0.003906c-9.6914-12.562-22.43-22.441-37.012-28.699-2.2734-0.95703-4.8633-0.79688-7 0.4375-8.9961 5.0898-19.152 7.7695-29.488 7.7891-10.309-0.011719-20.438-2.6914-29.398-7.7891-2.1367-1.2344-4.7266-1.3945-7-0.4375-14.594 6.2773-27.359 16.152-37.102 28.699-11.434-17.699-16.094-38.93-13.129-59.793 2.9688-20.863 13.363-39.953 29.277-53.766 15.914-13.812 36.281-21.418 57.352-21.418 21.074 0 41.438 7.6055 57.352 21.418 15.914 13.812 26.312 32.902 29.277 53.766 2.9688 20.863-1.6953 42.094-13.129 59.793z"/>
							<path d="m509.51 103.16c-9.5352 0-18.684 3.7891-25.43 10.531-6.7422 6.7461-10.531 15.891-10.531 25.43s3.7891 18.684 10.531 25.43c6.7461 6.7422 15.895 10.531 25.43 10.531 9.5391 0 18.688-3.7891 25.43-10.531 6.7461-6.7461 10.535-15.891 10.535-25.43s-3.7891-18.684-10.535-25.43c-6.7422-6.7422-15.891-10.531-25.43-10.531zm0 56.086c-5.332-0.023438-10.438-2.1602-14.195-5.9453-3.7539-3.7852-5.8555-8.9062-5.8398-14.238 0.015626-5.332 2.1445-10.441 5.9219-14.203 3.7812-3.7617 8.8984-5.8711 14.23-5.8633 5.332 0.007812 10.445 2.1328 14.211 5.9062 3.7695 3.7734 5.8867 8.8867 5.8867 14.219 0 5.3516-2.1328 10.484-5.9258 14.262-3.793 3.7773-8.9375 5.8867-14.289 5.8633z"/>
							<path d="m87.5 392.79c-0.023438 27.316 10.809 53.527 30.113 72.859 19.305 19.328 45.496 30.199 72.816 30.215 27.32 0.015625 53.523-10.824 72.852-30.133 19.324-19.312 30.188-45.508 30.195-72.828 0.007813-27.316-10.84-53.52-30.156-72.84-19.312-19.32-45.516-30.176-72.832-30.176-27.293 0.023437-53.461 10.871-72.766 30.16-19.309 19.289-30.176 45.449-30.223 72.742zm102.99 87.5c-24.035 0.007813-47.004-9.9375-63.438-27.477 7.6016-10.891 17.836-19.68 29.75-25.551 21.145 10.742 46.145 10.742 67.285 0 11.852 5.8125 22.051 14.508 29.664 25.289-16.383 17.512-39.281 27.457-63.262 27.473zm0-174.39v-0.003906c20.859 0.15625 40.98 7.7578 56.73 21.434 15.75 13.68 26.094 32.535 29.168 53.168 3.0781 20.633-1.3203 41.688-12.398 59.363-9.7734-12.5-22.531-22.34-37.102-28.613-2.2734-0.95703-4.8633-0.79688-7 0.4375-18.258 10.379-40.629 10.379-58.887 0-2.1367-1.2344-4.7266-1.3945-7-0.4375-14.559 6.2539-27.293 16.098-37.012 28.613-9.0312-14.035-13.805-30.387-13.738-47.074 0.09375-23.102 9.3164-45.227 25.66-61.555 16.34-16.328 38.477-25.527 61.578-25.598z"/>
							<path d="m190.49 400.75c9.5352 0 18.684-3.7891 25.43-10.531 6.7422-6.7461 10.531-15.895 10.531-25.43 0-9.5391-3.7891-18.688-10.531-25.43-6.7461-6.7461-15.895-10.535-25.43-10.535-9.5391 0-18.688 3.7891-25.43 10.535-6.7461 6.7422-10.535 15.891-10.535 25.43 0 9.5352 3.7891 18.684 10.535 25.43 6.7422 6.7422 15.891 10.531 25.43 10.531zm0-56.176c5.3594 0 10.5 2.1289 14.293 5.9219 3.7891 3.7891 5.918 8.9297 5.918 14.293 0 5.3594-2.1289 10.5-5.918 14.289-3.793 3.793-8.9336 5.9219-14.293 5.9219-5.3633 0-10.504-2.1289-14.293-5.9219-3.7891-3.7891-5.9219-8.9297-5.9219-14.289 0-5.3633 2.1328-10.504 5.9219-14.293 3.7891-3.793 8.9297-5.9219 14.293-5.9219z"/>
							<path d="m335.12 413.52c-4.0508 0.42969-7.1289 3.8438-7.1289 7.9219 0 4.0742 3.0781 7.4922 7.1289 7.918h167.21c4.3984 0 7.9648-3.5664 7.9648-7.9648v-76.211l4.0234 4.0234c3.1016 3.0703 8.0977 3.0703 11.199 0 3.0625-3.0703 3.0625-8.0391 0-11.109l-17.5-17.5c-1.4883-1.4727-3.5039-2.293-5.5977-2.2773-2.0703-0.011719-4.0547 0.80859-5.5117 2.2773l-17.5 17.5c-3.0703 3.0898-3.0508 8.0859 0.042969 11.156 3.0938 3.0664 8.0859 3.0469 11.156-0.046874l4.0234-4.0234v68.336z"/>
							<path d="m358.05 145.69h-167.3c-4.3477 0-7.875 3.5273-7.875 7.875v76.211l-4.1133-4.0234c-3.0703-3.0586-8.0391-3.0586-11.113 0-3.0664 3.1016-3.0664 8.0977 0 11.199l17.5 17.5c3.125 3.0234 8.0781 3.0234 11.203 0l17.5-17.5c3.0664-3.1016 3.0664-8.0977 0-11.199-3.0742-3.0586-8.043-3.0586-11.113 0l-4.1133 4.1133v-68.426h159.43c4.3477 0 7.875-3.5273 7.875-7.875s-3.5273-7.875-7.875-7.875z"/>
							<path d="m372.49 207.46-24.324-4.7266v0.003906c-4.2773-0.84766-8.4297 1.9336-9.2773 6.2109-0.84375 4.2773 1.9375 8.4297 6.2148 9.2773l5.6875 1.0508-62.039 41.648c-2.9141 1.9297-4.2031 5.5508-3.1719 8.8867 1.0312 3.3398 4.1406 5.5977 7.6328 5.5508 1.5586 0 3.0781-0.45703 4.375-1.3125l61.688-41.648-0.52344 5.5977c-0.80078 4.2969 2.0117 8.4375 6.3008 9.2734h1.4883c3.7617-0.015626 6.9883-2.6914 7.6992-6.3867l4.7266-24.414-0.003906 0.003906c0.37891-2.0625-0.097657-4.1836-1.3164-5.8867-1.2227-1.6992-3.0859-2.8281-5.1562-3.1289z"/>
							<path d="m411.25 285.51-61.25 41.648 1.0508-5.6016v0.003906c0.84375-4.2773-1.9375-8.4297-6.2148-9.2734-4.2734-0.84766-8.4297 1.9336-9.2734 6.2109l-4.7266 24.324c-0.80078 4.2969 2.0117 8.4375 6.3008 9.2773l24.324 4.7266h1.4883v-0.003906c3.9727-0.15625 7.2031-3.2461 7.5391-7.207 0.33203-3.9609-2.3359-7.5469-6.2266-8.3672l-5.5117-1.0508 61.25-41.562c3.6094-2.4727 4.5508-7.3984 2.1016-11.023-2.4375-3.5469-7.2695-4.4805-10.852-2.1016z"/>
						</g>
					</svg>
					`,

					name: `Деловая игра позволяет организовать совместную работу и взаимодействие команд. В процессе игры участники:`,

					paragraphs: [
						{id: 1, name: 'распределят роли и повысят слаженность командной работы',},
						{id: 2, name: 'обменяются опытом и знаниями в неформальной обстановке',},
						{id: 3, name: 'улучшат понимание и ускорят развитие своей роли в команде',},
						{id: 4, name: 'прокачают навык коммуникации',},
					],

					desc: `Важнейший эффект – сплочение коллектива и повышение его продуктивности.`,

				},
			},

			
		])

		const filter_objects = computed(() => objects.value.filter((o) => o.active))


		function select(object){

			for(let object of objects.value){
				object.active = false
			}

			object.active = true
		}

		return { domain, objects, select, filter_objects, }
	},
}

</script>
